import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { StripeProvider } from './context/StripeProvider';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AdventuresPage from './pages/AdventuresPage';
import AdventureDetailPage from './pages/AdventureDetailPage';
import TypicalWeekendPage from './pages/TypicalWeekendPage';
import GalleryPage from './pages/GalleryPage';
import ReviewsPage from './pages/ReviewsPage';
import AboutPage from './pages/AboutPage';
import NewBookPage from './pages/NewBookPage';
import BookingSuccessPage from './pages/BookingSuccessPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import CustomerDetailsPage from './pages/CustomerDetailsPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function App() {
  return (
    <StripeProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
          <Routes>
            {/* Admin Route - No Navigation/Footer */}
            <Route path="/admin/*" element={<AdminDashboard />} />
            
            {/* Regular Routes with Navigation/Footer */}
            <Route path="/*" element={
              <>
                <Navigation />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/adventures" element={<AdventuresPage />} />
                  <Route path="/adventures/:slug" element={<AdventureDetailPage />} />
                  <Route path="/weekend" element={<TypicalWeekendPage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/reviews" element={<ReviewsPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/book" element={<NewBookPage />} />
                  <Route path="/booking-success" element={<BookingSuccessPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/customer-details/:bookingReference" element={<CustomerDetailsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                </Routes>
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </StripeProvider>
  );
}

export default App;